import React from 'react';
import PropTypes from 'prop-types';
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonList,
  IonItem,
  IonLabel,
  IonIcon,
  IonNote,
  IonProgressBar,
  IonRow,
  IonCol
} from '@ionic/react';
import { connect } from 'react-redux'

import './UserData.css';
import UserDataActions from '../../../actions/userdata';
import { RESOURCES } from '../../../constants/system';
import ErrorAlert from '../../../components/ErrorAlert';

interface IProps {
  getUser: any;
}

interface IState {
  data: any;
}

class UserData extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props)
    this.state = {data: props.data}
  }

  componentDidMount(){
    this.props.getUser({}, "get_profile");
  }

  UNSAFE_componentWillReceiveProps(nextProps: any){
    this.setState({
      data: nextProps.data,
    });
  }

  render() {
    const { user, centro, error, error401, loading } = this.state.data;
    return (
      <IonPage>
        <ErrorAlert/>
        <IonHeader>
          <IonToolbar color="primary">
            <IonTitle>Mi perfil</IonTitle>
            <IonButtons slot="start">
              <IonMenuButton />
            </IonButtons>
          </IonToolbar>
        </IonHeader>

        <IonContent fullscreen>
          <h1 style={error || error401 && !loading ? {display: "block"} : {display: "none"}} className="ion-text-center">Error en el sistema, consulte con el administador de la aplicación.</h1>
          <IonProgressBar style={ loading ? {display: 'block'} : {display: 'none'}} type="indeterminate"></IonProgressBar>

          <IonList style={ !error && !error401 && !loading ? {display: "block"} : {display: "none"}}>
            <IonRow class="ion-padding-top">
              <IonCol className="ion-align-self-start" size="2"></IonCol>
              <IonCol className="ion-align-self-center">
                <img className="circleImg" alt="" src={`${ RESOURCES }usuarios/${ user.imagen }`} />
              </IonCol>
              <IonCol className="ion-align-self-end" size="2"></IonCol>
            </IonRow>
            <IonItem>
              <IonLabel>Nombre</IonLabel>
              <IonNote slot="end" color="primary">{user.name}</IonNote>
            </IonItem>

            <IonItem>
              <IonLabel>Usuario</IonLabel>
              <IonNote slot="end" color="secondary">{user.username}</IonNote>
            </IonItem>

            <IonItem>
              <IonLabel>Email</IonLabel>
              <IonNote slot="end" color="tertiary">{user.email}</IonNote>
            </IonItem>

            <IonItem>
              <IonLabel>Centro</IonLabel>
              <IonNote slot="end" color="success">{centro ? centro.empresa : ""}</IonNote>
            </IonItem>

            <IonItem>
              <IonLabel>Perfil</IonLabel>
              <IonNote slot="end" color="warning">{user.strdescripcion}</IonNote>
            </IonItem>

            <IonItem>
              <IonLabel>Código del Centro</IonLabel>
              <IonNote slot="end" color="danger">{centro ? centro.serial : ""}</IonNote>
            </IonItem>
          </IonList>

        </IonContent>
      </IonPage>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    data: state.data,
    getUser: PropTypes.func.isRequired
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getUser: (fields: any, typeOptions: string) => dispatch(UserDataActions.getUser(fields, typeOptions)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(UserData);

